
import './App.css';

import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import "@fortawesome/fontawesome-free/css/all.min.css";
import Header from './components/Header';
import HeroSection from './components/HeroSlider';
import Footer from './components/Footer';
import ContactSection from './pages/ContactSection';
import AboutSection from './components/AboutSection';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import TermsConditions from './pages/TermsConditions';
import PrivacyPolicy from './pages/PrivacyPolicy';
import GallerySection from './pages/GallerySection';
import Booking from './pages/Booking';
import Ourfleets from './pages/Ourfleets';
import Punecabservice from './pages/Pune Cab Service';
import Enquiry from './pages/Enquiry';
import ScrollToTop from './components/ScrollToTop';
import Punetaxihire from './pages/Pune Taxi Hire';
import Puneonlinecabsbooking from './pages/Pune Online Cabs Booking';
import Bestcabserviceinpune from './pages/Best Cabs Service in Pune';
import Punetomumbaicab from './pages/Pune to Mumbai Cab';
import Punetonashikcabs from './pages/Pune to Nasik Cabs';
import Punetomahabaleshwarcab from './pages/Pune to Mahabaleshwar Cab';
import Punetolonavalacab from './pages/Pune to Lonavala Cab';
import Punetotrimbkeshwarcab from './pages/Pune to Trimbakeshwar Cab';
import Punetoshirdicab from './pages/Pune to Shirdi Cab';
import Punetobhimashankarcab from './pages/Pune to Bhimashankar Cab';
import Punetoindorecabs from './pages/Pune to Indore Cabs';
import Punetokonkandarshancab from './pages/Pune to Konkan Darshan Cab';
import Punecabfare from './pages/Pune Cab Fare';
import Puneoutstationcab from './pages/Pune Outstation Cabs';
import Punetopanchganicab from './pages/Pune to Panchgani Cab';
import Punetomumbaiinternatinalairportcab from './pages/Pune to Mumbai International Airport Cab';
import Ashtavinayakdarshancab from './pages/Ashtavinayak Darshan Cab';
import Punetonagpurcab from './pages/Pune to Nagpur Cab';
import Punetogoacab from './pages/Pune to Goa Cab';
import Punetoajantaelloracab from './pages/Pune to Ajanta Ellora Cab';
import Punetosataracabs from './pages/Pune to Satara Cabs';
import Puneairportcabs from './pages/Pune Airport Cabs';
import Punetoayodhyatourpackage from './pages/Pune to Ayodhya Tour Package';
import Corporatecabserviceinpune from './pages/Corporate Cab Service in Pune';
import Punetomumbaiairportcab from './pages/Pune to Mumbai Airport Cab';
import Punetokolhapurcabs from './pages/Pune to Kolhapur Cabs';
import Punetopandharpurtaxi from './pages/Pune to Pandharpur Taxi';
import Tempotravelleronrentinpune from './pages/Tempo Traveller On Rent in Pune';
import Urbaniaonrentinpune from './pages/Urbania On Rent in Pune';
import Innovacrystaonrentpinpune from './pages/Innova Crysta On Rent in Pune';
import Innovacabsonrentinpune from './pages/Innova Cabs on Rent in Pune ';
import Punetoujjaincab from './pages/Pune to Ujjain Cab';
import Swiftdzireonrentinpune from './pages/Swift Dzire On Rent In Pune';
import Punetosomnathjyotilingacabserv from './pages/Pune to Somnath Jyotirlinga Cab Service';
import Punetoimagicacab from './pages/Pune to Imagica Cab';
import Minibusonrentinpune from './pages/Mini Bus On Rent in Pune';
import Ertigaonrentinpune from './pages/Ertiga On Rent in Pune';
import Kiacarenceonrentinpune from './pages/Kia Carens On Rent in Pune';
import Punetosambhajinagartaxifare from './pages/Pune to Sambhaji Nagar Taxi fare';
import Punetoganpatipuletaxi from './pages/Pune to Ganpatipule Taxi';
import Punetoakkalkotcab from './pages/Pune to Akkalkot Cab';
import Punetoalibagcabs from './pages/Pune to Alibag Cabs';
import Punetopanvelcabs from './pages/Pune to Panvel Cabs';
import Punetohyderabadcab from './pages/Pune to Hyderabad Cabs';
import Punetobangloretaxiservice from './pages/Pune to Bangalore Taxi Service';
import Onewaycabpune from './pages/One Way Cab Pune';
import Taxiserviceinhadapsar from './pages/Taxi Service in Hadapsar';
import Taxiserviceinlohegaon from './pages/Taxi Service in Lohegaon';
import Cabserviceinvimannagar from './pages/Cab Service in Viman Nagar';
import Cabserviceinkharadi from './pages/Cab Service in Kharadi';
import Taxiservicehinjewadipune from './pages/Taxi Service in Hinjewadi Pune';
import Punetogujratcabservice from './pages/Pune to Gujarat Cab Service';
import Travelagentsinpune from './pages/Travel Agents in Pune';
import Punetothanecab from './pages/Pune to Thane Cab';
import Outstationtaxiservicepune from './pages/Outstation Taxi Service Pune';
import Cabbookinginpune from './pages/Cab Booking in Pune';
import Onlinecabbookingpune from './pages/Online Cab Booking Pune';
import Punetomumbaionewaycab from './pages/Pune to Mumbai One Way Cab';
import Punemumbaicarhire from './pages/Pune Mumbai Car Hire';
import Punetomumbaionlinecabbooking from './pages/Pune to Mumbai Online Cab Booking ';
import Pimprichichwadtomumbaicab from './pages/Pimpri Chinchwad to Mumbai Cabs';
import Banertomumbaicab from './pages/Baner to Mumbai Cabs';
import Hinjewaditomumbaicabs from './pages/Hinjewadi to Mumbai Cabs';
import Pimplesaudartomumbaicabservice from './pages/Pimple Saudagar to Mumbai Cab Service';
import Wakadtomumbaicab from './pages/Wakad to Mumbai Cab';
import Hadapsartomuumbaicab from './pages/Hadapsar to Mumbai Cabs';
import Kalyaninagartomumbaitaxi from './pages/Kalyani Nagar to Mumbai Taxi';
import Koregaonparktomumbaicab from './pages/Koregaon Park to Mumbai Cab';
import Kothrudtomumbaicab from './pages/Kothrud to Mumbai Cab';
import Kharaditomumbaicab from './pages/Kharadi to Mumbai Cab';
import Shivajinagartomumbaicab from './pages/Shivajinagar to Mumbai Cab';
import Punetomumbaiertigacab from './pages/Pune to Mumbai Ertiga Cabs';
import Kondhwatomumbaicab from './pages/Kondhwa to Mumbai Cab ';
import Vimannagartomumbaicabs from './pages/Viman Nagar to Mumbai Cabs';
import Katrajtomumbaicabservice from './pages/Katraj to Mumbai Cab Service';
import Punestationtomumbaicabsservice from './pages/Pune Station to Mumbai Cabs Service';
import Boatclubroadtomumbaicab from './pages/Boat Club Road to Mumbai Cab';
import Vishrantwaditomuumbaicab from './pages/Vishrantwadi to Mumbai Cab';
import Alannditomumbaicabservice from './pages/Alandi to Mumbai Cabs Service';
import Wagholitomumbaicab from './pages/Wagholi to Mumbai Cab';
import Cabserviceinpimprichichwad from './pages/Cab Service in Pimpri Chinchwad';
import Cabserviceinchichwad from './pages/Cab Service in Chinchwad';
import Cabserviceinbhosari from './pages/Cab Service in Bhosari';
import Cabserviceinnigdipradhikaran from './pages/Cab Service in Nigdi Pradhikaran';
import Cabserviceunakurdi from './pages/Cab Service in Akurdi';
import Cabserviceinwakadpune from './pages/Cab Service in Wakad Pune ';
import Cabserviceinpimplesaudagar from './pages/Cab Service in Pimple Saudagar';
import Cabserviceinpimplegurav from './pages/Cab Service in Pimple Gurav';
import Cabserviceinravet from './pages/Cab Service in Ravet';
import Cabserviceinmoshipune from './pages/Cab Service in Moshi Pune';
import Cabserviceinchiklipune from './pages/Cab Service in Chikhali Pune';
import Cabserviceinsangvipune from './pages/Cab Service in Sangvi Pune';
import Cabserviceinrahatani from './pages/Cab Service in Rahatani';
import Cabserviceinthergaon from './pages/Cab Service in Thergaon';
import Cabserviceintalawadepune from './pages/Cab Service in Talawade Pune';
import Cabserviceindapoli from './pages/Cab Service in Dapoli';
import Cabserviceinkasarwadi from './pages/Cab Service in Kasarwadi ';
import Cabserviceinpunawala from './pages/Cab Service in Punawale';
import Cabserviceintathwadepune from './pages/Cab Service in Tathawade Pune';
import Cabserviceinbanerpune from './pages/Cab Service in Baner Pune';
import Employeetransportationservice from './pages/Employee Transportation Services Pune';
import Officecabservicepune from './pages/Office Cab Service Pune';
import Corporatetaxiservicepune from './pages/Corporate Taxi Service Pune';
import Monthlycabserviceinpune from './pages/Monthly Cab Service in Pune';
import Corporatebusserviceinpune from './pages/Corporate Bus Services in Pune';
import Cabserviceforcorporateeventsinpune from './pages/Cab Service for Corporate Events in Pune';
import Busrentalforcorporateeventsinpune from './pages/Bus Rental for Corporate Events in Pune';
import Panindiacabservicefrompune from './pages/Pan India Cab Service from Pune';
import Packages from './pages/Packages';
import Services from './pages/Services';
import ContactButtons from './components/ContactButtons';
import FaqSection from './pages/FaqSection';
import Laturtopunecabservice from './pages/Latur to Pune Cab Service';
import Kolhapurtopunecabservice from './pages/Kolhapur to Pune Cab Service ';
import Pandharpurtopunecab from './pages/Pandharpur to Pune Cabs';
import Solapurtopunecabservice from './pages/Solapur to Pune Cab Service';
import Sambhajinagartopunecab from './pages/Sambhaji Nagar to Pune Cabs';
import Nashiktopunecabservice from './pages/Nashik to Pune Cab Service';
import Punetojalgaoncabservice from './pages/Pune to Jalgaon Cab Service';
import Punetodhulecab from './pages/Pune to Dhule Cab Service';
import Alibaugtopunecab from './pages/Alibag to Pune Cab';
import Mahabaleshawartopunecab from './pages/Mahabaleshwar to Pune Cab';
import Lonavalatopunecab from './pages/Lonavala to Pune Cabs';
import Ahilyanagartopunecabs from './pages/Ahilya Nagar to Pune Cabs';
import Baramatitopunecab from './pages/Baramati to Pune Cab';
import Nagpurtopunecab from './pages/Nagpur to Pune Cab';
import Thanetopunecabservice from './pages/Thane to Pune Cab Service';
function App() {
  return (
    <Router>
<Header/>
      <ContactButtons />
      <ScrollToTop />

      <Routes>
        <Route path="/" element={<HeroSection />} />
        <Route path="/about-us" element={<AboutSection />} />
        <Route path="/term-condition" element={<TermsConditions />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/gallery" element={<GallerySection />} />
        <Route path="/services" element={<Services />} />
        <Route path="/booking" element={<Booking />} />
        <Route path="/our-fleet" element={<Ourfleets />} />
        <Route path="/packages" element={<Packages />} />
        <Route path="/Faqs" element={<FaqSection />} />
        <Route path="/contact-us" element={<ContactSection />} />
        <Route path="/enquiry" element={<Enquiry />} />
        <Route path="/Pune-Cab-Service" element={<Punecabservice />} />
      

<Route path="/Pune-Taxi-Hire" element={<Punetaxihire />} />
<Route path="/Pune-Online-Cabs-Booking" element={<Puneonlinecabsbooking />} />
<Route path="/Best-Cabs-Service-in-Pune" element={<Bestcabserviceinpune />} />
<Route path="/Pune-to-Mumbai-Cab" element={<Punetomumbaicab />} />
<Route path="/Pune-to-Nasik-Cabs" element={<Punetonashikcabs />} />
<Route path="/Pune-to-Mahabaleshwar-Cab" element={<Punetomahabaleshwarcab />} />
<Route path="/Pune-to-Lonavala-Cab" element={<Punetolonavalacab />} />
<Route path="/Pune-to-Trimbakeshwar-Cab" element={<Punetotrimbkeshwarcab />} />
<Route path="/Pune-to-Shirdi-Cab" element={<Punetoshirdicab />} />
<Route path="/Pune-to-Bhimashankar-Cab" element={<Punetobhimashankarcab />} />
<Route path="/Pune-to-Indore-Cabs" element={<Punetoindorecabs />} />
<Route path="/Pune-to-Konkan-Darshan-Cab" element={<Punetokonkandarshancab />} />
<Route path="/Pune-Cab-Fare" element={<Punecabfare />} />
<Route path="/Pune-Outstation-Cabs" element={<Puneoutstationcab />} />
<Route path="/Pune-to-Panchgani-Cab" element={<Punetopanchganicab />} />
<Route path="/Pune-to-Mumbai-International-Airport-Cab" element={<Punetomumbaiinternatinalairportcab />} />
<Route path="/Ashtavinayak-Darshan-Cab" element={<Ashtavinayakdarshancab />} />
<Route path="/Pune-to-Nagpur-Cab" element={<Punetonagpurcab />} />
<Route path="/Pune-to-Goa-Cab" element={<Punetogoacab />} />
<Route path="/Pune-to-Ajanta-Ellora-Cab" element={<Punetoajantaelloracab />} />
<Route path="/Pune-to-Satara-Cabs" element={<Punetosataracabs />} />
<Route path="/Pune-Airport-Cabs" element={<Puneairportcabs />} />
<Route path="/Pune-to-Ayodhya-Tour-Package" element={<Punetoayodhyatourpackage />} />
<Route path="/Corporate-Cab-Service-in-Pune" element={<Corporatecabserviceinpune />} />
<Route path="/Pune-to-Mumbai-Airport-Cab" element={<Punetomumbaiairportcab />} />
<Route path="/Pune-to-Kolhapur-Cabs" element={<Punetokolhapurcabs />} />
<Route path="/Pune-to-Pandharpur-Taxi" element={<Punetopandharpurtaxi />} />
<Route path="/Tempo-Traveller-On-Rent-in-Pune" element={<Tempotravelleronrentinpune />} />
<Route path="/Urbania-On-Rent-in-Pune" element={<Urbaniaonrentinpune />} />
<Route path="/Innova-Crysta-On-Rent-in-Pune" element={<Innovacrystaonrentpinpune />} />
<Route path="/Innova-Cabs-on-Rent-in-Pune" element={<Innovacabsonrentinpune />} />
<Route path="/Pune-to-Ujjain-Cab" element={<Punetoujjaincab />} />
<Route path="/Swift-Dzire-On-Rent-In-Pune" element={<Swiftdzireonrentinpune />} />
<Route path="/Pune-to-Somnath-Jyotirlinga-Cab-Service" element={<Punetosomnathjyotilingacabserv />} />
<Route path="/Pune-to-Imagica-Cab" element={<Punetoimagicacab />} />
<Route path="/Mini-Bus-On-Rent-in-Pune" element={<Minibusonrentinpune />} />
<Route path="/Ertiga-On-Rent-in-Pune" element={<Ertigaonrentinpune />} />
<Route path="/Kia-Carens-On-Rent-in-Pune" element={<Kiacarenceonrentinpune />} />


<Route path="/Pune-to-Sambhaji-Nagar-Taxi-fare" element={<Punetosambhajinagartaxifare />} />
<Route path="/Pune-to-Ganpatipule-Taxi" element={<Punetoganpatipuletaxi />} />
<Route path="/Pune-to-Akkalkot-Cab" element={<Punetoakkalkotcab />} />
<Route path="/Pune-to-Alibag-Cabs" element={<Punetoalibagcabs />} />
<Route path="/Pune-to-Panvel-Cabs" element={<Punetopanvelcabs />} />
<Route path="/Pune-to-Hyderabad-Cabs" element={<Punetohyderabadcab />} />
<Route path="/Pune-to-Bangalore-Taxi-Service" element={<Punetobangloretaxiservice />} />
<Route path="/One-Way-Cab-Pune" element={<Onewaycabpune />} />
<Route path="/Taxi-Service-in-Hadapsar" element={<Taxiserviceinhadapsar />} />
<Route path="/Taxi-Service-in-Lohegaon" element={<Taxiserviceinlohegaon />} />
<Route path="/Cab-Service-in-Viman-Nagar" element={<Cabserviceinvimannagar />} />
<Route path="/Cab-Service-in-Kharadi" element={<Cabserviceinkharadi />} />
<Route path="/Taxi-Service-in-Hinjewadi-Pune" element={<Taxiservicehinjewadipune />} />
<Route path="/Pune-to-Gujarat-Cab-Service" element={<Punetogujratcabservice />} />
<Route path="/Travel-Agents-in-Pune" element={<Travelagentsinpune />} />
<Route path="/Pune-to-Thane-Cab" element={<Punetothanecab />} />
<Route path="/Outstation-Taxi-Service-Pune" element={<Outstationtaxiservicepune />} />
<Route path="/Cab-Booking-in-Pune" element={<Cabbookinginpune />} />
<Route path="/Online-Cab-Booking-Pune" element={<Onlinecabbookingpune />} />
<Route path="/Pune-to-Mumbai-One-Way-Cab" element={<Punetomumbaionewaycab />} />
<Route path="/Pune-Mumbai-Car-Hire" element={<Punemumbaicarhire />} />
<Route path="/Pune-to-Mumbai-Online-Cab-Booking" element={<Punetomumbaionlinecabbooking />} />
<Route path="/Pimpri-Chinchwad-to-Mumbai-Cabs" element={<Pimprichichwadtomumbaicab />} />
<Route path="/Baner-to-Mumbai-Cabs" element={<Banertomumbaicab />} />
<Route path="/Hinjewadi-to-Mumbai-Cabs" element={<Hinjewaditomumbaicabs />} />
<Route path="/Pimple-Saudagar-to-Mumbai-Cab-Service" element={<Pimplesaudartomumbaicabservice />} />
<Route path="/Wakad-to-Mumbai-Cab" element={<Wakadtomumbaicab />} />
<Route path="/Hadapsar-to-Mumbai-Cabs" element={<Hadapsartomuumbaicab />} />
<Route path="/Kalyani-Nagar-to-Mumbai-Taxi" element={<Kalyaninagartomumbaitaxi />} />
<Route path="/Koregaon-Park-to-Mumbai-Cab" element={<Koregaonparktomumbaicab />} />
<Route path="/Kothrud-to-Mumbai-Cab" element={<Kothrudtomumbaicab />} />
<Route path="/Kharadi-to-Mumbai-Cab" element={<Kharaditomumbaicab />} />
<Route path="/Shivajinagar-to-Mumbai-Cab" element={<Shivajinagartomumbaicab />} />
<Route path="/Pune-to-Mumbai-Ertiga-Cabs" element={<Punetomumbaiertigacab />} />
<Route path="/Kondhwa-to-Mumbai-Cab" element={<Kondhwatomumbaicab />} />
<Route path="/Viman-Nagar-to-Mumbai-Cabs" element={<Vimannagartomumbaicabs />} />
<Route path="/Katraj-to-Mumbai-Cab-Service" element={<Katrajtomumbaicabservice />} />

<Route path="/Pune-Station-to-Mumbai-Cabs-Service" element={<Punestationtomumbaicabsservice />} />
<Route path="/Boat-Club-Road-to-Mumbai-Cab" element={<Boatclubroadtomumbaicab />} />
<Route path="/Vishrantwadi-to-Mumbai-Cab" element={<Vishrantwaditomuumbaicab />} />
<Route path="/Alandi-to-Mumbai-Cabs-Service" element={<Alannditomumbaicabservice />} />
<Route path="/Wagholi-to-Mumbai-Cab" element={<Wagholitomumbaicab />} />
<Route path="/Cab-Service-in-Pimpri-Chinchwad" element={<Cabserviceinpimprichichwad />} />
<Route path="/Cab-Service-in-Chinchwad" element={<Cabserviceinchichwad/>} />
<Route path="/Cab-Service-in-Bhosari" element={<Cabserviceinbhosari />} />
<Route path="/Cab-Service-in-Nigdi-Pradhikaran" element={<Cabserviceinnigdipradhikaran />} />
<Route path="/Cab-Service-in-Akurdi" element={<Cabserviceunakurdi />} />
<Route path="/Cab-Service-in-Wakad-Pune" element={<Cabserviceinwakadpune />} />
<Route path="/Cab-Service-in-Pimple-Saudagar" element={<Cabserviceinpimplesaudagar />} />
<Route path="/Cab-Service-in-Pimple-Gurav" element={<Cabserviceinpimplegurav />} />
<Route path="/Cab-Service-in-Ravet" element={<Cabserviceinravet />} />
<Route path="/Cab-Service-in-Moshi-Pune" element={<Cabserviceinmoshipune />} />
<Route path="/Cab-Service-in-Chikhali-Pune" element={<Cabserviceinchiklipune />} />
<Route path="/Cab-Service-in-Sangvi-Pune" element={<Cabserviceinsangvipune />} />
<Route path="/Cab-Service-in-Rahatani" element={<Cabserviceinrahatani />} />
<Route path="/Cab-Service-in-Thergaon" element={<Cabserviceinthergaon />} />
<Route path="/Cab-Service-in-Talawade-Pune" element={<Cabserviceintalawadepune />} />
<Route path="/Cab-Service-in-Dapoli" element={<Cabserviceindapoli />} />
<Route path="/Cab-Service-in-Kasarwadi" element={<Cabserviceinkasarwadi />} />
<Route path="/Cab-Service-in-Punawale" element={<Cabserviceinpunawala />} />
<Route path="/Cab-Service-in-Tathawade-Pune" element={<Cabserviceintathwadepune />} />
<Route path="/Cab-Service-in-Baner-Pune" element={<Cabserviceinbanerpune />} />
<Route path="/Employee-Transportation-Services-Pune" element={<Employeetransportationservice />} />
<Route path="/Office-Cab-Service-Pune" element={<Officecabservicepune />} />
<Route path="/Corporate-Taxi-Service-Pune" element={<Corporatetaxiservicepune />} />
<Route path="/Monthly-Cab-Service-in-Pune" element={<Monthlycabserviceinpune />} />
<Route path="/Corporate-Bus-Services-in-Pune" element={<Corporatebusserviceinpune />} />
<Route path="/Cab-Service-for-Corporate-Events-in-Pune" element={<Cabserviceforcorporateeventsinpune />} />
<Route path="/Bus-Rental-for-Corporate-Events-in-Pune" element={<Busrentalforcorporateeventsinpune />} />
<Route path="/Pan-India-Cab-Service-from-Pune" element={<Panindiacabservicefrompune />} />


<Route path="/Latur-to-Pune-Cab-Service" element={<Laturtopunecabservice />} />
<Route path="/Kolhapur-to-Pune-Cab-Service" element={<Kolhapurtopunecabservice />} />
<Route path="/Pandharpur-to-Pune-Cabs" element={<Pandharpurtopunecab />} />
<Route path="/Solapur-to-Pune-Cab-Service" element={<Solapurtopunecabservice />} />
<Route path="/Sambhaji-Nagar-to-Pune-Cabs" element={<Sambhajinagartopunecab />} />
<Route path="/Nashik-to-Pune-Cab-Service" element={<Nashiktopunecabservice />} />
<Route path="/Pune-to-Jalgaon-Cab-Service" element={<Punetojalgaoncabservice />} />
<Route path="/Pune-to-Dhule-Cab-Service" element={<Punetodhulecab />} />
<Route path="/Alibag-to-Pune-Cab" element={<Alibaugtopunecab />} />
<Route path="/Mahabaleshwar-to-Pune-Cab" element={<Mahabaleshawartopunecab />} />
<Route path="/Lonavala-to-Pune-Cabs" element={<Lonavalatopunecab />} />
<Route path="/Ahilya-Nagar-to-Pune-Cabs" element={<Ahilyanagartopunecabs />} />
<Route path="/Baramati-to-Pune-Cab" element={<Baramatitopunecab />} />
<Route path="/Nagpur-to-Pune-Cab" element={<Nagpurtopunecab />} />
<Route path="/Thane-to-Pune-Cab-Service" element={<Thanetopunecabservice />} />
      </Routes>



      <Footer />
    </Router>
  );
}

export default App;
